module.exports = __webpack_public_path__ + "img/diners club.1aa43e7d.png";